import { Tooltip, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { findAllProfissionaisExternosAndInterno, sujeitoAtencaoOrcamentoHeader } from "../../../../../../../../services/OrcamentoService";
import moment from "moment";
import { Button } from "../../../../../../../../components/ui/Buttons";
import OrcamentoEmitidoIcon from "../../../../../../../../components/Icon/OrcamentoEmitidoIcon";
import { withRouter } from "react-router-dom";
import { TextFieldSearch } from "../../../../../../../../components/TextField";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";

const dadosSujeitoAtencaoDefault = {
  nome: "",
  contato: {
    telefonePrincipal: "",
    email: "",
  },
};
const HeaderOdontologico = observer(
  ({ classes, sujeitoAtencao, orcamento, history, orcamentoStore }) => {
    const [dadosSujeitoAtencao, setDadosSujeitoAtencao] = useState(
      dadosSujeitoAtencaoDefault
    );

    const { nome, contato } = dadosSujeitoAtencao || {};
    const {
      statusOrcamentoOdontologico,
      dataHoraLancamento,
      id: orcamentoId,
      numero,
    } = orcamento || {};
    const { id } = sujeitoAtencao || {};

    const isTelaPaciente = history.location.pathname.includes("sujeito-atencao");

    useEffect(() => {
      sujeitoAtencao?.id && getDadosSujeitoAtencao();
    }, [sujeitoAtencao]);

    const getDadosSujeitoAtencao = async () => {
      try {
        const response = await sujeitoAtencaoOrcamentoHeader(id);
        setDadosSujeitoAtencao(response);
      } catch (error) {
        console.error(error);
      }
    };

    const loadProfissionaisSaude = async (search, loadedOptions, { page }) => {
      const pageableDTO = {
        pageNumber: page,
        pageSize: 10,
        sortDir: "ASC",
        sortField: "nome",
      };
  
      try {
        const { content, last } = await findAllProfissionaisExternosAndInterno({
          pageableDTO,
          search,
          ativo: true
        });
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error(error);
      }
    }

    return (
      <div className={classes.container}>
        <div className={classes.orcamentoNome}>
          <div className={classes.nomeSujeito}>
            <h2>{nome}</h2>
            { !isTelaPaciente && <Tooltip title="Ir para orçamentos">
              <Button
                id="prt-hoo-btn-iro"
                shape="circle"
                bgColor="#219A97"
                onClick={() =>
                  history.push(`/sujeito-atencao/edit/${id}/orcamentos`)
                }
                padding={0}
                style={{ height: 24, width: 24, display: "flex" }}
              >
                <OrcamentoEmitidoIcon size='14' />
              </Button>
            </Tooltip>}
          </div>
          {orcamentoId && (
            <div className={classes.field}>
              <p className={classes.nameField}>Nº:</p>
              <p>{numero}</p>
            </div>
          )}
        </div>
        <div className={classes.row}>
          <div className={classes.field}>
            <p className={classes.nameField}>Telefone:</p>
            <p>{contato?.telefonePrincipal || orcamento?.sujeitoAtencao?.contato?.telefonePrincipal}</p>
          </div>
          <div className={classes.field}>
            <p className={classes.nameField}>E-mail:</p>
            <p>{contato?.email || orcamento?.sujeitoAtencao?.contato?.email}</p>
          </div>
        </div>
        <div className={classes.row}>
            <div className={classes.field}>
              <p className={classes.nameField}>Status:</p>
              <p>{statusOrcamentoOdontologico?.nome || ""}</p>
            </div>
          {orcamentoId && (
            <div className={classes.field} style={{
              display: 'flex',
              justifyContent: 'flex-end',
              flex:1}}>
              <p className={classes.nameField}>Lançamento:</p>
              <p>{moment(dataHoraLancamento).format("DD/MM/YYYY HH:mm")}</p>
            </div>
          )}
        </div>
          <div className={classes.contentProfissionais}>
          <div className={classes.fieldProfissional}>
            <span className={classes.titleInput}>Orçamentista:</span>
            <TextFieldSearch
              id="prt-hoo-sel-orc"
              placeholder='Selecione'
              classIcons={classes.classIcons}
              classInput={classes.reactSelect}
              classNotched={classes.notchedOutline}
              loadOptions={loadProfissionaisSaude}
              getOptionLabel={option => option?.nome}
              getOptionValue={option => option?.id}
              value={orcamentoStore.orcamento.orcamentista}
              classes={{ paper: classes.menuHeight }}
              onChange={e => orcamentoStore.handleFieldModal('orcamentista', e)}
              withPaginate
              debounceTimeout={300}
              additional={{
                page: 0,
              }}
              menuPosition='fixed'
              isClearable={false}
            />
          </div>

          <div className={classes.fieldProfissional}>
            <span className={classes.titleInput}>Profissional Executante:</span>
            <TextFieldSearch
              id="prt-hoo-sel-pex"
              placeholder='Selecione'
              classIcons={classes.classIcons}
              classInput={classes.reactSelect}
              classNotched={classes.notchedOutline}
              loadOptions={loadProfissionaisSaude}
              getOptionLabel={option => option?.nome}
              getOptionValue={option => option?.id}
              value={orcamentoStore.orcamento.profissionalExecutante}
              classes={{ paper: classes.menuHeight }}
              onChange={e => orcamentoStore.handleFieldModal('profissionalExecutante', e)}
              withPaginate
              debounceTimeout={300}
              additional={{
                page: 0,
              }}
              menuPosition='fixed'
            />
          </div>
        </div>
      </div>
    );
  }
);

const style = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  orcamentoNome: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "& > h2": {
      margin: 0,
    },
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px",
  },
  field: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
    "& > p": {
      margin: 0,
    },
    textWrap: 'nowrap',
  },
  fieldStatus: {
    display: 'flex',
    gap: '10px',
    width:'100%'
  },
  nameField: {
    fontSize: "12px",
    color: "#505050",
  },
  nomeSujeito: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    "& h2": {
      margin: 0,
    }
  },
  contentSelectOrcamentista:{
    width:"115px",
  },
  contentProfissionais: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
  },
  fieldProfissional: {
    flex: 1,
    maxWidth: "50%",
  },
};

const HeaderOdontologicoWithStylesRouter = withRouter(
  withStyles(style)(HeaderOdontologico)
);
export default inject("orcamentoStore")(HeaderOdontologicoWithStylesRouter);
